import { getSiteCmsMediaUsageApi } from '@/lib/api/siteCmsApi';
import type { SiteCmsOwnerType } from '@shared/types/entities';
import { useQuery } from '@tanstack/react-query';

export const cmsMediaUsageKey = (ownerType: SiteCmsOwnerType, ownerId: number) =>
  ['site-cms', 'media-usage', ownerType, ownerId] as const;
export function useCmsMediaUsage(ownerType: SiteCmsOwnerType, ownerId: number) {
  return useQuery({
    queryKey: cmsMediaUsageKey(ownerType, ownerId),
    queryFn: () => getSiteCmsMediaUsageApi(ownerType, ownerId),
    staleTime: 10_000,
    refetchOnMount: 'always',
    retry: false,
  });
}
